import React, { useState } from 'react';
import { X } from 'lucide-react';
const privacyContent = <div className="space-y-4 text-slate-300 text-sm leading-relaxed" data-id="element-23">
    <h3 className="text-xl font-bold text-white" data-id="element-24">Política de Privacidad</h3>
    <p data-id="element-25">
      <strong className="text-white" data-id="element-26">Última actualización:</strong> Abril 2026
    </p>

    <h4 className="text-lg font-bold text-white mt-6" data-id="element-27">
      1. Información que Recopilamos
    </h4>
    <p data-id="element-28">
      Recopilamos únicamente la información necesaria para procesar tu compra,
      incluyendo nombre, correo electrónico y datos de pago. No almacenamos
      información de tarjetas de crédito en nuestros servidores.
    </p>

    <h4 className="text-lg font-bold text-white mt-6" data-id="element-29">
      2. Uso de la Información
    </h4>
    <p data-id="element-30">Tu información personal se utiliza exclusivamente para:</p>
    <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-31">
      <li data-id="element-32">Procesar y entregar tu compra digital.</li>
      <li data-id="element-33">Enviarte actualizaciones relacionadas con el producto adquirido.</li>
      <li data-id="element-34">Responder a consultas de soporte.</li>
    </ul>

    <h4 className="text-lg font-bold text-white mt-6" data-id="element-35">
      3. Protección de Datos
    </h4>
    <p data-id="element-36">
      Utilizamos encriptación SSL de 256 bits para proteger toda la información
      transmitida. Tus datos personales nunca serán vendidos, alquilados ni
      compartidos con terceros con fines de marketing.
    </p>

    <h4 className="text-lg font-bold text-white mt-6" data-id="element-37">4. Cookies</h4>
    <p data-id="element-38">
      Nuestro sitio puede utilizar cookies para mejorar la experiencia del
      usuario y analizar el tráfico del sitio. Puedes desactivar las cookies en
      la configuración de tu navegador.
    </p>

    <h4 className="text-lg font-bold text-white mt-6" data-id="element-39">5. Tus Derechos</h4>
    <p data-id="element-40">
      Tienes derecho a solicitar acceso, corrección o eliminación de tus datos
      personales en cualquier momento.
    </p>
  </div>;
const termsContent = <div className="space-y-4 text-slate-300 text-sm leading-relaxed" data-id="element-41">
    <h3 className="text-xl font-bold text-white" data-id="element-42">Términos y Condiciones</h3>
    <p data-id="element-43">
      <strong className="text-white" data-id="element-44">Última actualización:</strong> Abril 2026
    </p>

    <h4 className="text-lg font-bold text-white mt-6" data-id="element-45">
      1. Aceptación de los Términos
    </h4>
    <p data-id="element-46">
      Al acceder y utilizar este sitio web y adquirir nuestros productos
      digitales, aceptas cumplir con estos términos y condiciones en su
      totalidad.
    </p>

    <h4 className="text-lg font-bold text-white mt-6" data-id="element-47">
      2. Naturaleza del Producto
    </h4>
    <p data-id="element-48">
      La "Guía de Crédito 700+" es un producto educativo e informativo. No
      constituye asesoramiento legal, financiero ni profesional. Los resultados
      pueden variar según la situación individual de cada persona.
    </p>

    <h4 className="text-lg font-bold text-white mt-6" data-id="element-49">3. Producto Digital</h4>
    <p data-id="element-50">
      Al completar tu compra, recibirás acceso inmediato al contenido digital.
      Dado que se trata de un producto descargable, todas las ventas son finales
      una vez que se ha accedido al contenido.
    </p>

    <h4 className="text-lg font-bold text-white mt-6" data-id="element-51">4. Uso Permitido</h4>
    <p data-id="element-52">
      El contenido adquirido es para uso personal únicamente. Queda prohibida la
      reproducción, distribución, reventa o compartición del material sin
      autorización expresa por escrito.
    </p>

    <h4 className="text-lg font-bold text-white mt-6" data-id="element-53">
      5. Limitación de Responsabilidad
    </h4>
    <p data-id="element-54">
      No garantizamos resultados específicos en tu puntaje de crédito. El éxito
      depende de múltiples factores, incluyendo tu situación crediticia actual y
      la correcta aplicación de las estrategias proporcionadas.
    </p>

    <h4 className="text-lg font-bold text-white mt-6" data-id="element-55">6. Modificaciones</h4>
    <p data-id="element-56">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Las modificaciones entrarán en vigor inmediatamente después de su
      publicación en el sitio.
    </p>
  </div>;
export function Footer() {
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-navy-950 py-8 text-center text-sm text-slate-500 border-t border-slate-800" data-id="element-57">
        <div className="max-w-7xl mx-auto px-4" data-id="element-58">
          <p data-id="element-59">
            © {new Date().getFullYear()} Guía de Crédito 700+. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs max-w-2xl mx-auto" data-id="element-60">
            Descargo de responsabilidad: Los resultados pueden variar. Esta guía
            proporciona información educativa y no constituye asesoramiento
            legal o financiero profesional.
          </p>
          <div className="mt-4 flex items-center justify-center gap-4" data-id="element-61">
            <button onClick={() => setModal('privacy')} className="text-slate-400 hover:text-gold-400 transition-colors underline underline-offset-2" data-id="element-62">
              Política de Privacidad
            </button>
            <span className="text-slate-700" data-id="element-63">|</span>
            <button onClick={() => setModal('terms')} className="text-slate-400 hover:text-gold-400 transition-colors underline underline-offset-2" data-id="element-64">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal */}
      {modal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setModal(null)} data-id="element-65">
          <div className="relative w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-2xl bg-navy-800 border border-slate-700/50 p-6 sm:p-8 shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-66">
            <button onClick={() => setModal(null)} className="absolute top-4 right-4 flex h-8 w-8 items-center justify-center rounded-full bg-navy-900 text-slate-400 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-67">
              <X className="h-5 w-5" data-id="element-68" />
            </button>
            {modal === 'privacy' ? privacyContent : termsContent}
          </div>
        </div>}
    </>;
}